module.exports = __webpack_public_path__ + "img/schema 1.09fe6489.svg";